import { GBP } from '../../lib/gbp'
import { defaultWashFrom } from '../../lib/wash-order'

// The wire shape of /api/v2/services, camelCased.
//
// `key`, `slug`, `section`, `pageRank` and `onPricesPage` were added on
// 5 October 2026 so that /services could stop holding its own hardcoded list
// of service names and read the catalogue instead. They describe where a
// service belongs on the prices page and they are decided server side, in
// app/services/customer_catalogue.rb: see client/gwmc/lib/service-catalogue.js
// for what reads them. The booking form ignores them.
export const servicesAdapter = array =>
  array.map(item => {
    const {
      // eslint-disable-next-line prettier/prettier
      group,
      id,
      key,
      name,
      description,
      customer_price: customerPrice,
      customer_price_cents: customerPriceCents,
      gwmc_price: gwmcPrice,
      includes,
      excludes,
      slug,
      section,
      page_rank: pageRank,
      on_prices_page: onPricesPage,
      most_booked: mostBooked,
      default_wash: defaultWash,
      featured_extras: featuredExtras
    } = item || {}

    return {
      group,
      id,
      key,
      name,
      description,
      customerPrice,
      customerPriceCents,
      gwmcPrice,
      price: GBP(customerPriceCents / 100),
      includes,
      excludes,
      slug,
      section,
      pageRank,
      onPricesPage,
      mostBooked: !!mostBooked,
      defaultWash: !!defaultWash,
      // Washes only: the ids of the three extra chips Book & pay shows for it
      // (config/catalogue/featured_extras.yml, lib/featured-extras.js).
      featuredExtras: featuredExtras || []
    }
  })

// The wash a booking starts on when the link names none: the row the server
// flags `default_wash` (CustomerCatalogue::DEFAULT_WASH, Mini Valet since
// 25 Oct 2026), else the `most_booked` one, else the first base wash if both
// are ever retired. A ?service= link or a restored draft is applied on top of
// this by the booking screen and always wins.
export const defaultBaseService = defaultWashFrom
